module.exports = __webpack_public_path__ + "da982bb2bec68a79d8589e41cab4619b.pdf";